//

export const defaultElement = 'span';
export const textElements = ['span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const textWeights = ['regular', 'medium', 'semiBold'];
export const textVariants = ['textXs', 'textSm', 'textMd', 'textLg', 'displaySm', 'displayMd', 'displayLg', 'displayXl', 'display1xl', 'display2xl'];

//